// src/pages/PaymentResultPage.jsx
import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PaymentResultPage = () => {
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success') === 'true';
  const message = searchParams.get('message') || '';
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full mx-4 text-center">
        <div className="text-5xl mb-4">
          {success ? '✅' : '❌'}
        </div>
        <h2 className="text-2xl font-bold mb-2 text-gray-800">
          {success ? 'پرداخت موفق' : 'پرداخت ناموفق'}
        </h2>
        <p className="text-gray-600 mb-8">{message}</p>
        <div className="flex gap-3 justify-center">
          {success && (
            <button
              onClick={() => navigate('/profile/wallet')}
              className="px-6 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
            >
              مشاهده کیف پول
            </button>
          )}
          <button
            onClick={() => navigate('/')}
            className="px-6 py-2 bg-gray-200 text-gray-700 rounded-xl hover:bg-gray-300 transition"
          >
            بازگشت به خانه
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentResultPage;